export default {
    "pending": "Chờ xử lý",
    "resolved": "Đã xử lý",
}
